import { render, staticRenderFns } from "./DesignFormAuthFormModal.vue?vue&type=template&id=2ee3d2f4&scoped=true&"
import script from "./DesignFormAuthFormModal.vue?vue&type=script&lang=js&"
export * from "./DesignFormAuthFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee3d2f4",
  null
  
)

export default component.exports